export default {
  'goldkid-open-button:text': 'Оформить Kaspi Gold для ребенка',
  'goldkid-open:agreement': 'Нажимая на кнопку, я соглашаюсь на обработку <span class="text-action-link link-300">персональных данных</span>',
  'goldkid-open:get-card': 'Получить карту'
}
